/* eslint-disable import/no-duplicates */
import React from 'react';
import PropTypes from 'prop-types';
import {HORIZONTAL} from 'constants/direction';
import {VERTICAL} from 'constants/direction';
import {MOVE} from 'constants/event-type';
import {getHeight, getWidth} from 'utils/layout-util';
import styles from './index.css';

export default class InteractionSurface extends React.Component {
  static propTypes = {
    direction: PropTypes.oneOf([HORIZONTAL, VERTICAL]),
    handleMove: PropTypes.func,
    handleOut: PropTypes.func,
    height: PropTypes.number,
    tickRange: PropTypes.number,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    direction: HORIZONTAL,
    handleMove: () => {},
    handleOut: () => {},
    height: 0,
    tickRange: 0,
    width: 0,
    x: 0,
    y: 0,
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.handleInteraction = this.handleInteraction.bind(this);
  }

  componentDidMount() {
    const {handleOut} = this.props;
    const {current} = this.ref;
    current.addEventListener('mousemove', this.handleInteraction);
    current.addEventListener('mouseout', handleOut);
    current.addEventListener('touchend', handleOut);
    current.addEventListener('touchmove', this.handleInteraction);
  }

  componentWillUnmount() {
    const {handleOut} = this.props;
    const {current} = this.ref;
    current.removeEventListener('mousemove', this.handleInteraction);
    current.removeEventListener('mouseout', handleOut);
    current.removeEventListener('touchend', handleOut);
    current.removeEventListener('touchmove', this.handleInteraction);
  }

  getCoords(event) {
    const {clientX, clientY, target} = event;
    const {left, top} = target.getBoundingClientRect();
    return [clientX - left, clientY - top];
  }

  render() {
    const {height, width, x, y} = this.props;
    const rectHeight = getHeight(height);
    const rectWidth = getWidth(width);
    return (
      <rect
        className={styles.InteractionSurface}
        height={rectHeight}
        ref={this.ref}
        width={rectWidth}
        x={x}
        y={y}
      />
    );
  }

  handleInteraction(event) {
    const {direction, handleMove, tickRange} = this.props;

    // Get interaction coordinates.
    const coords = this.getCoords(event);
    const [x, y] = coords;

    // Get data index corresponding to interaction coordinates.
    const xy = direction === HORIZONTAL ? 0 : 1;
    const activeIndex = Math.floor(coords[xy] / tickRange);

    // Get closest index to mouse coords.
    // This is used for positioning on line and area series.
    const rangeOfIndexes = [
      Math.floor(coords[xy] / tickRange),
      Math.ceil(coords[xy] / tickRange),
    ];
    const closest = rangeOfIndexes
      .map((datum) => tickRange * datum)
      .reduce((previous, current, index) =>
        Math.abs(current - coords[xy]) < Math.abs(previous - coords[xy])
          ? index
          : index - 1,
      );
    const closestIndex = rangeOfIndexes[closest];

    handleMove({
      activeIndex,
      closestIndex,
      type: MOVE,
      x,
      y,
    });
  }
}
